//export const API_URL = "http://192.168.8.111:8000/";
export const API_URL = "https://www.sla-az.org/";
//export const API_URL = "https://7ce6-142-113-9-255.ngrok-free.app/";
export interface LoginResponse {
  success: boolean;
  access_token: string;
  token_type: string;
  login_session: {
      user: {[key: string]: string},
      carriers: [],
      users: { [key: string]: string },
      usersReverse: { [key: string]: string },
      slcodes: { [key: string]: string }
      balance: "",
      nonresident: boolean,
      welcomeNotice: number,
      warningNotice: number,
  }
}
export interface ErrorResponse {
  success: boolean;
  errorMsg : string;
}

export type LoginResult = LoginResponse | ErrorResponse;

export interface FetchFilingRequest{
  userid: number,
  posted: string,
  searchWords: string
  licenseNumber: string,
}

export interface ExcelFilingRequest{
  fetchRequest: FetchFilingRequest,
  bShort: boolean
}
export interface FilingData{
  id: number,
  brokerID: number,
  userID: number,
  licenseNumber: string,
  filingMethod: string,
  sourceDocument: string,
  insuredName: string,
  insuredAddress: string,
  policyNumber: string,
  transType: string,
  transDate: Date,
  transEffectiveDate: Date,
  policyEffectiveDate: Date,
  late:string,
  slCode: string,
  premium: number,
  policyFee: number,
  tax: number,
  stampingFee: number,
  latefee: number,
  warning: string,
  warningMessage: string,
  period: string,
  carriers:
    {
      name: string,
      NAIC: string,
      percent: number
    }[]
}
export interface FetchFilingResponse {
  success: boolean,
  fetchedList: FilingData[],
}

export type FetchFilingResult = FetchFilingResponse | ErrorResponse;

export interface GetFilingResponse {
  success: boolean,
  filing: FilingData,
}

export type GetFilingResult = GetFilingResponse | ErrorResponse;

  export interface FilingProps{
    user: {[key: string]: string},
    carriers: string[],
    users: { [key: string]: string },
    slcodes: { [key: string]: string },
    isSelected: boolean
  }

  export interface CarriersProps{
    carriers:{name: string,NAIC: string, Percent: number}[]
  }

  export interface RowFiling {
    validate: string,
    id: number,
    late: string,
    policynumber: string,
    transType: string,
    insuredName: string,
    insuredAddress: string,
    transEffectiveDate: Date,
    policyEffectiveDate: Date,
    transDate: Date,
    slCode: string,
    premium:string,
    policyFee:string,
    tax: string,
    stampingFee:string,
    latefee: string,
    period: string,
    carriers:string,
  }

  export interface RegisterRequest{
    firstName: string,
    lastName: string,
    licenseeName: string,
    phoneNumber: string,
    emailAddress: string,
    licenseNumber: string,
    licenseNumber2: string,
    username: string,
    password: string,
    password2: string
  }

  export interface RegisterResponse{
    success: boolean,
    msg: string
  }

  export interface ResetPasswordRequest{
    username: string,
    emailAddress: string,
    licenseNumber: string,
    password: string,
    password2: string
  }

  
  export interface LoginRequest{
    username: string,
    password: string,
  }

  export interface FilingHistoryData{
    seqID: number,
    postDate: Date,
    edtr: string,
    fileName: string,
    totalLines: number,
    linesAccepted: number,
    linesRejected: number,
    totalPremium: number,
    premiumAccepted: number,
    premiumRejected: number,
    totalPolicyFees: number,
    policyFeesAccepted: number,
    policyFeesRejected: number,
    totalTax: number,
    taxAccepted: number,
    taxRejected: number,
    totalStFee: number,
    stFeeAccepted: number,
    stFeeRejected: number,
    penalty: number,
    invoice: string
  }
export interface LateFilingData{
  DTRID: number,
  date: Date,
  license: string,
  broker: string,
  tax: number,
  penalty: number,
  duedate: string,
  balance: number,
  paidamount: number,
  status: string,
  notes: string,
}
export interface FetchHistoryResponse{
  success: boolean,
  filing: FilingHistoryData[]
}

export interface FetchLateResponse{
  success: boolean,
  filing: LateFilingData[]
}
export type FetchHistoryResult = FetchHistoryResponse | ErrorResponse;
export type FetchLateResult = FetchLateResponse | ErrorResponse;

export interface UpdateDTRResponse{
  success: boolean,
  dtr: LateFilingData
}
export type UpdateDTRResult = UpdateDTRResponse | ErrorResponse;


export interface AccountData{
    transID: number,
    transDate: Date,
    licenseNumber: string,
    postSequenceID: number,
    checkNumber: string,
    amount: number,
    balance: number
}
export interface FecthAccountResponse{
  success: boolean,
  record: AccountData[]
}
export type FecthAccountResult = FecthAccountResponse | ErrorResponse;

export interface AddFilingResponse{
  success: boolean,
  newfiling: FilingData
}
export type AddFilingResult = AddFilingResponse | ErrorResponse;

export interface PostFilingRequest{
  bLateProcess: boolean,
}

export interface UploadExcelResponse{
  success: boolean,
  code: number,
  filings: FilingData[]
}

export type UploadExcelResult = UploadExcelResponse | ErrorResponse

export interface BrokerData{
  brokername: string,
  stateID: string,
  email: string,
  sbsID: string,
}
export interface ChangeLicenseResponse{
  success: boolean
  broker: BrokerData | null
  msg: string
}

export interface GetNumberResponse{
  success: boolean,
  welcome: number,
  warning: number
}

export type GetNumberResult = GetNumberResponse | ErrorResponse

export interface BulkEmailRequest{
  istest: boolean,
  subject: string,
  content: string,
  recipient: number,
  attachment: File | null
}

export interface TaskResponse{
  success: boolean,
  taskid: string | null,
  progress: number,
  errorMsg: string
}